import axiosInstance from '../../../config/axiosInstance';
const  SupplierService = {
    async GetAllSuppliers(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/GetAllSuppliers?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AllNewSuppliers(redirectCallback,Start, PageSize, searchQuery, sortColumn, sortDirection,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
             const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Supplier/AllNewSuppliers?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSupplierCount(redirectCallback,searchQuery,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Supplier/GetSupplierCount?ClientID=${ClientID}&searchQuery=${searchQuery}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAssetByID(redirectCallback,ID) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
           const response = await axiosInstance.get(`/Asset/GetAssetByID?ID=${ID}&ClientID=${ClientID}`);
           return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSupplierByID(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/GetSupplierByID?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSupplierNotes(redirectCallback,ID) {
        try {            
           
         const response = await axiosInstance.get(`/Supplier/GetSupplierNotes?ID=${ID}`);
           return response.data;
        } catch (error) {
           
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSupplier(redirectCallback,ID) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
           const idString = ID.join(',');
           const response = await axiosInstance.get(`/Supplier/DeleteSupplier?ID=${idString}`);
           return response.data;
        } catch (error) {
           
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async LockSupplier(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Supplier/LockSupplier?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockSupplier(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Supplier/UnLockSupplier?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SyncSupplierToFinancial(ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Customer/SyncCustomerToFinancialApp?ID=${idString}&ClientID=${ClientID}&UserID=${UserID}&action=Supplier`);
            if (response.data) {
                if (response.data.authUrl) {
                    // Open QuickBooks auth popup
                    const authPopup = window.open(
                        response.data.authUrl,
                        'QuickbookAuth',
                        'width=600,height=700,top=100,left=100'
                    );

                    if (!authPopup) {
                        throw new Error('Popup blocked. Please enable popups.');
                    }

                    // Polling to wait for user to close the popup
                    const interval = setInterval(() => {
                        if (authPopup.closed) {
                            clearInterval(interval);
                            console.log('Popup closed. Retrying QuickBooks customer creation...');
                            // Retry once popup is closed
                            //  this.QuickbookAddCustomer(ClientCompanyID);
                        }
                    }, 500);
                    return;
                } else {
                    // Success case
                    return response.data;
                }
            }

        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    
};

export default SupplierService;